import {Component, OnInit, inject, signal} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';
import { TranslateService} from '@ngx-translate/core';
import {CdkDropList, moveItemInArray} from '@angular/cdk/drag-drop';
import {fuseAnimations} from '../../../core/animations';
import {CompetencyService} from '../../../core/services/competency.service';
import {SharedModule} from '../../../core/modules/shared.module';
import {MaterialModule} from '../../../core/modules/material.module';
import {PagesContainerComponent} from '../pages-container/pages-container.component';
import {EditCompetencyModalComponent} from './edit-competency-modal/edit-competency.modal';
import {FuseDeleteDialogComponent} from '../../../core/components/delete-dialog/delete-dialog.component';
interface Competency {
  title: string;
  color: string;
  skills: Skill[];
  id: number;
}
interface Skill {
  title: string;
  orderId: number;
  id: number;
}
@Component({
  selector: 'competency-page',
  templateUrl: './competency.component.html',
  styleUrls: ['./competency.component.scss'],
  animations: fuseAnimations,
  standalone: true,
  imports: [CdkDropList, MaterialModule, SharedModule, PagesContainerComponent],
  providers: [CompetencyService]
})

export class CompetencyComponent implements OnInit{
  private competencyService = inject(CompetencyService);
  private dialog = inject(MatDialog);
  private translate = inject(TranslateService);
  private toastr = inject(ToastrService);

  search = signal('');
  competencies = signal<Competency[]>([]);

  ngOnInit() {
    this.getCompetencies();
  }

  handleSearch(value) {
    this.search.set(value);
    this.getCompetencies();
  }

  getCompetencies() {
    this.competencyService.getCompetenciesWithSkills(this.search()).subscribe((res: any) => {
      this.competencies.set(res);
    });
  }

  editCompetency(compotency) {
    const dialogRef = this.dialog.open(EditCompetencyModalComponent , {
      width: '400px',
      data: {title: compotency.title, color: compotency.color, header: 'competency.edit_competency'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          id: compotency.id,
          title: result.title,
          color: result.color,
          orderId: compotency.orderId
        };
        this.competencyService.addCompetency(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('competency.competency_edited');
            this.toastr.success(msg, title);
            this.competencies.update((prevCompetencies) => {
              return prevCompetencies.map((comp) => {
                  if (comp.id === res.id) {
                    return {
                      ...res,
                      skills: comp.skills
                    };
                  }
                  return comp;
                });
            });
          }
        });
      }
    });
  }

  deleteCompetency (id) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'competency.delete_competency'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.competencyService.deleteCompetency(id).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('competency.competency_deleted');
            this.toastr.success(msg, title);
            this.competencies.update((prevCompetencies) => {
              return prevCompetencies.filter((comp) => comp.id !== id);
            });
          }
        });
      }
    });
  }

  editSkill(skill) {
    const dialogRef = this.dialog.open(EditCompetencyModalComponent , {
      width: '400px',
      data: {title: skill.title, header: 'competency.edit_skill'}
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          id: skill.id,
          title: result,
          competencyId: skill.competencyId,
          orderId: skill.orderId
        };
        this.competencyService.addSkill(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('competency.skill_edited');
            this.toastr.success(msg, title);
            this.competencies.update((prevCompetencies) => {
              return prevCompetencies.map((comp) => {
                if (comp.id === skill.competencyId) {
                  return {
                    ...comp,
                    skills: comp.skills.map((s) => (s.id === res.id ? res : s))
                  };
                }
                return comp;
              });
            });
          }
        });
      }
    });
  }

  deleteSkill (skill) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'competency.delete_skill'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.competencyService.deleteSkill(skill.id).subscribe((res: any) => {
          if (res && !res.error) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('competency.skill_deleted');
            this.toastr.success(msg, title);
            this.competencies.update((prevCompetencies) => {
              return prevCompetencies.map((comp) => {
                if (comp.id === skill.competencyId) {
                  return {
                    ...comp,
                    skills: comp.skills.filter((s) => s.id !== skill.id)
                  };
                }
                return comp;
              });
            });
          }
        });
      }
    });
  }

  addSkill(comId) {
    const dialogRef = this.dialog.open(EditCompetencyModalComponent , {
      width: '400px',
      data: {title: '', header: 'competency.add_skill'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          title: result,
          competencyId: comId,
          orderId: this.competencies().find(el => el.id === comId).skills.length
        };
        this.competencyService.addSkill(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('competency.skill_added');
            this.toastr.success(msg, title);
            this.competencies.update((prevCompetencies) => {
              return prevCompetencies.map((comp) => {
                if (comp.id === comId) {
                  return {
                    ...comp,
                    skills: [...comp.skills, res]
                  };
                }
                return comp;
              });
            });
          }
        });
      }
    });
  }

  drop(event: any, index) {
    const skills = [...this.competencies()[index].skills];
    moveItemInArray(skills, event.previousIndex, event.currentIndex);
    this.competencies.update(prev => {
      const newCompetencies = [...prev];
      newCompetencies[index] = {
        ...newCompetencies[index],
        skills: skills.map((el, i) => { el.orderId = i; return el; })
      };
      return newCompetencies;
    });
    this.competencyService.addCompetency(this.competencies()[index]).subscribe();
  }

  dropCompetency(event: any) {
    this.competencies.update(prev => {
      const newArray = [...prev];
      moveItemInArray(newArray, event.previousIndex, event.currentIndex);
      return newArray;
    });
    const orderUpdates = this.competencies().map((comp, index) => ({
      id: comp.id,
      orderId: index
    }));
    this.competencyService.updateCompetenciesOrder(orderUpdates).subscribe({
      next: () => {
        this.toastr.success(this.translate.instant('successfully'), 'Success');
        this.getCompetencies();
      },
      error: () => {
        this.toastr.error('Error: dropCompetency');
      }
    });
  }
}
